<div *ngIf="allNyhet" class="page-container">
  <app-cards [cards]="allNyhet" [page]="null" [useCustomOrdering]="false"></app-cards>
</div>

<div *ngIf="!allNyhet|| isLoading" class="page-container page">
  <h2>Vennligst vent mens nyhetsarkivet lastes. Dette kan ta litt tid.</h2>
</div>

